var path = require('path');

module.exports = function(npath, ext) {
  if (typeof npath !== 'string') return npath;
  if (npath.length === 0) return npath;

  var nFileName = path.basename(npath, path.extname(npath))+ext;
  return path.join(path.dirname(npath), nFileName);
};


//////////////////
// WEBPACK FOOTER
// ./~/replace-ext/index.js
// module id = 3870
// module chunks = 0